import { darkContextualBorderPalette } from './darkContextualBorderPalette'
import { contextualBorderPalette } from './contextualBorderPalette'

export type Variation = {
  name: 'light' | 'dark'
  theme: { shadows?: Record<string, string> }
}
export const darkTheme = {
  name: 'dark',
  theme: {
    shadows: darkContextualBorderPalette,
  },
} as const

export const lightTheme = {
  name: 'light',
  theme: {
    shadows: contextualBorderPalette,
  },
} as const
